module.exports = __webpack_public_path__ + "static/media/shutterstock_111494318.41ce0225.jpg";